import { InfiniteData } from "@tanstack/react-query";

import { ActionBO } from "@/api/graphql/actions/types.ts";
import { UserActions } from "@/api/graphql/actions/user/types.ts";
import { GetActionsByUserQueryQuery } from "@/api/graphql/types/graphql.ts";
import { convertTimestamp } from "@/utils/date";

export const fromUserActionsToDisplayableUserActions = (
  rawActions: UserActions,
): Array<ActionBO> =>
  rawActions?.map((rawAction) => {
    const { dateString, timeString } = convertTimestamp(
      rawAction.whenTs,
      "DD.MM.YYYY",
      "HH[h]mm",
    );

    return {
      id: rawAction.id,
      date: dateString,
      time: timeString,
      name: rawAction.action,
      agent: {
        id: rawAction.AgentIdData?.id || "",
        firstName: rawAction.AgentIdData?.firstName || "",
        lastName: rawAction.AgentIdData?.lastName || "",
        igg: rawAction.AgentIdData?.AccessIdData?.igg || "",
      },
    };
  });

export const reducePages = (
  queryResult: InfiniteData<GetActionsByUserQueryQuery>,
): ActionBO[] => {
  if (!queryResult.pages) {
    return [];
  }

  const allUserActions = queryResult.pages.reduce<UserActions>(
    (acc, current) => {
      const data = current.AccountsMsSearchAuditLogs.data;

      if (data) {
        return [...acc, ...data];
      }

      return acc;
    },
    [],
  );

  return fromUserActionsToDisplayableUserActions(allUserActions);
};
